/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Npi utils for practice & provider
 */
import _ from 'lodash';

import { statusMapping } from 'components/widgets/button/IdentityVerification';
import { FIELD_VALIDATORS } from 'app-constants/index';
import { getNpiMeta } from 'utils/workflow';

const commonAttributes = {
	name: '',
	timings: [],
	phones: [],
	emails: [],
	smlinks: {},
	messagingapps: [],
	image: null as unknown as string,
	npi: null,
	registeredName: null,
	registry: null,
};

/**
 * is valid npi code
 */
const isValidNpi = (code: string): string | undefined => {
	const isValid = FIELD_VALIDATORS.npi.pattern.test(code);
	if (isValid) {
		return code;
	}
};

/**
 * getProviderName
 */
const getProviderName = (registry?: Provider.IRegistry): string | null => {
	return (
		_.join(_.without([registry?.basic?.first_name, registry?.basic?.middle_name, registry?.basic?.last_name], '--'), ' ') ||
		commonAttributes.registeredName
	);
};

/**
 * getAuthorizedName
 */
const getAuthorizedOfficialName = (registry?: Provider.IRegistry): string | null => {
	return (
		_.join(
			_.without(
				[
					registry?.basic?.authorized_official_name_prefix,
					registry?.basic?.authorized_official_first_name,
					registry?.basic?.authorized_official_middle_name,
					registry?.basic?.authorized_official_last_name,
					registry?.basic?.authorized_official_name_suffix,
				],
				'--',
			),
			' ',
		) || commonAttributes.registeredName
	);
};

/**
 * getPracticeName
 */
const getLocationName = (registry?: Provider.IRegistry): string | null => {
	return registry?.basic?.organization_name || commonAttributes.registeredName;
};

/**
 * function to convert to startCase
 */
const renderNPIHolderName = (text: string): string => {
	return _.startCase(_.toLower(text));
};

/**
 * function to check kyc status
 */
const isEkycCompletedNpi = (status: string): boolean => {
	return (
		status === statusMapping.verified.code ||
		status === statusMapping.verified_offline.code ||
		status === statusMapping.verified_transitive.code ||
		status === statusMapping.verified_ba.code
	);
};

const getRegistryMeta = (registry?: Provider.IRegistry): Provider.IRegistrySummaryItem[] => {
	const registrySummary = [];
	const { isProviderNPI, isLocationNPI } = getNpiMeta(registry?.enumeration_type);

	registrySummary.push({ label: 'NPI', value: registry?.number });
	if (isProviderNPI) {
		registrySummary.push({ label: 'Registered Name', value: getProviderName(registry) });
	}
	if (isLocationNPI) {
		registrySummary.push({ label: 'Registered Name', value: getLocationName(registry) });
		registrySummary.push({ label: 'Authorized Official', value: getAuthorizedOfficialName(registry) });
	}
	return registrySummary;
};

export {
	getLocationName,
	getProviderName,
	isEkycCompletedNpi,
	isValidNpi,
	renderNPIHolderName,
	getAuthorizedOfficialName,
	getRegistryMeta,
};
